import { createFileRoute } from '@tanstack/react-router';

import { type ChapterQuestionPage } from 'api/parsers/parseQuestionData';
import { type ChapterContentPage } from 'api/types/ChapterContent/ChapterContentPage';

import { getChapterContentOptions } from 'hooks/data/useChapterContent';
import { getChapterInfoOptions } from 'hooks/data/useChapterInfo';

import { RetainContentView } from 'views/RetainContentView';

const isContentPage = (data: ChapterContentPage | ChapterQuestionPage): data is ChapterContentPage => {
  return (data as ChapterQuestionPage).question === undefined;
};

type Search = {
  page: string | null;
};

export const Route = createFileRoute('/_auth/_buttonView/_layout/retain/_app/$id/$chapter/')({
  component: RetainContentView,
  staticData: {
    disableButtonBar: true,
    preventLayoutOverflow: true,
    disableLayout: true,
    disableLayoutMaxWidth: true,
    disablePointBar: true,
    back: {
      to: '/retain/$id/',
    },
  },
  validateSearch: (search: Record<string, unknown>): Search => {
    return {
      page: (search.page as string) || null,
    };
  },
  loader: async ({ context: { queryClient }, params }) => {
    const chapterContent = await queryClient.ensureQueryData(
      getChapterContentOptions({ id: params.id, chapterId: params.chapter }),
    );

    const chapters = await queryClient.ensureQueryData(getChapterInfoOptions(params));
    const chapter = chapters.find(({ id }) => {
      return id === params.chapter;
    });

    return {
      chapterContent: chapterContent.filter(isContentPage),
      chapter,
    };
  },
});
